import React, { useEffect, useState } from "react";
import {
  useSearchParams
} from "react-router-dom";
import {Form, Col, Row, Table, InputGroup, Modal, Button} from 'react-bootstrap';
import './syllabusTopic.css';
import '../css/main-style.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";


function getDisplayLang(lang) {
	switch(lang) {
		case "Bilingual-class" : return "英文(Bilingual)";
		case "Cantonese": return "中文(Cantonese)";
		case "Mandarin": return "中文(Mandarin)";
		case "Native-speaker-teacher-class": return "英文(Native)";
	}
	return "???";
}


export default function SyllabusTopic() {
	const navigate = useNavigate();
	let params = useParams();
  let codeId = params.codeId;
	
	const [rawData, setRawData] = useState({
		codeId:"", codeSubject:"", descriptionEn: "", descriptionHk:"", subCatEn:"", subCatHk:"", langType:"", levels:[], tagLevels:[], tags:[], allTags:[], allrcLevels:[], allTagLevels:[], 
	});
	const [updateData, setUpdateData] = useState({
		descriptionEn: "", descriptionHk:"", subCatEn:"", subCatHk:"", levels:[], tags:[]
	});
	
	const [show, setShow] = useState(false);
	const [displayLevelModal, setDisplayLevelModal] = useState(false);
	const [currentLevelIndex, setCurrentLevelIndex] = useState();
	
	const [showLevel, setShowLevel] = useState({
		currentR:null,
		confirmClick:false,
	});
	
	const fetchData = () => {		
	
		getData('syllabus/listSyllabusTopicDetail?codeId=' + codeId, navigate)
		.then(res => {
				setRawData(res.data);
				setUpdateData({
					descriptionEn:(res.data.descriptionEn) ? res.data.descriptionEn : "",
					descriptionHk:(res.data.descriptionHk) ? res.data.descriptionHk : "",
					subCatEn:res.data.subCatEn,
					subCatHk:res.data.subCatHk,
					levels:[...res.data.levels], 
					tags:[...res.data.tags]
				});
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	function isTagsDiff() {
		return !(rawData.tags.length === updateData.tags.length && rawData.tags.every((e, i) => e.tag === updateData.tags[i].tag && e.name_hk === updateData.tags[i].name_hk));
	}
	
	
	const updateTags = async () => {
		if (isTagsDiff()) {
			let obj = {
				'codeId' : rawData.codeId,
				'tags' : updateData.tags,
			}
			
      await postData("syllabus/updateSyllabusTag", obj, navigate); 
			setRawData((prev) => ({...prev, ['tags']:[...updateData.tags]}))
		}
	}
	
	const updateSubCatEn = async () => {
		if (rawData.subCatEn !== updateData.subCatEn) {
			let obj = {
				'codeId' : rawData.codeId,
				'subCatEn' : updateData.subCatEn,
			}
			await postData("syllabus/updateSyllabusBasic", obj, navigate); 
			setRawData(prev=>({...prev, ['subCatEn']:updateData.subCatEn}))
		}
	}
	
	const updateSubCatHk = async () => {
		if (rawData.subCatHk !== updateData.subCatHk) {
			let obj = {
				'codeId' : rawData.codeId,
				'subCatHk' : updateData.subCatHk,
			}
			await postData("syllabus/updateSyllabusBasic", obj, navigate); 
			setRawData(prev=>({...prev, ['subCatHk']:updateData.subCatHk}))
		}
	}
	
	const updateLevelNameEn = async (index, nameEn) => {
		if (updateData.levels[index].levelEn !== rawData.levels[index].levelEn) {
			let obj = {
				'codeId' : rawData.codeId,
				'oriRcLevel' : rawData.levels[index].rcLevel,
				'levelEn' : updateData.levels[index].levelEn,
			}
			await postData("syllabus/updateSyllabusLevelBasic", obj, navigate); 
			let objLevels = rawData.levels;
			objLevels[index].levelEn = nameEn;
			setRawData((prev)=>({...prev, ["levels"]:objLevels}));
		}
	}
	
	const updateLevelNameHk = async (index, nameHk) => {
		if (updateData.levels[index].levelHk !== rawData.levels[index].levelHk) {
			let obj = {
				'codeId' : rawData.codeId,
				'oriRcLevel' : rawData.levels[index].rcLevel,
				'levelHk' : updateData.levels[index].levelHk,
			}
			await postData("syllabus/updateSyllabusLevelBasic", obj, navigate); 
			let objLevels = rawData.levels;
			objLevels[index].levelHk = nameHk;
			setRawData((prev)=>({...prev, ["levels"]:objLevels}));
		}
	}
	
	const updateSyllabusRcLevel = async (index) => {		
		if (rawData.levels[index].rcLevel !== showLevel.currentR.rcLevel) {
			let obj = {
				'codeId' : rawData.codeId,
				'oriRcLevel' : rawData.levels[index].rcLevel,
				'rcLevel' : showLevel.currentR.rcLevel,
			}
			await postData("syllabus/updateSyllabusLevelBasic", obj, navigate); 
			let objLevels = rawData.levels;
			objLevels[index].rcLevel = showLevel.currentR.rcLevel;
			setRawData((prev)=>({...prev, ["levels"]:objLevels}));
			
			objLevels = updateData.levels;
			objLevels[index].rcLevel = showLevel.currentR.rcLevel;
			setUpdateData((prev)=>({...prev, ["levels"]:objLevels}));
			
		}
	}
	
	const updateDescriptionEn = async () => {
		if (rawData.descriptionEn !== updateData.descriptionEn) {
			let obj = {
				'codeId' : rawData.codeId,
				'descriptionEn' : updateData.descriptionEn,
			}
			await postData("syllabus/updateSyllabusBasic", obj, navigate); 
			setRawData((prev)=>({...prev, ["descriptionEn"]:updateData.descriptionEn}))
		}
		
		
		
	}
	
	
	const updateDescriptionHk = async () => {
		if (rawData.descriptionHk !== updateData.descriptionHk) {
			let obj = {
				'codeId' : rawData.codeId,
				'descriptionHk' : updateData.descriptionHk,
			}
			await postData("syllabus/updateSyllabusBasic", obj, navigate); 
			setRawData((prev)=>({...prev, ["descriptionHk"]:updateData.descriptionHk}))
		}
	}
	
	
	
	const chooseLevel = (r) => {
		setShowLevel((prev)=>({...prev, ['currentR']:r, ['confirmClick']:true}))		
	}
	
	const showOptionLevel = (r) => {
		if (showLevel.confirmClick) {
			return;
		}
		
		let tmp = {
			"rcLevel": r.rcLevel,
			"tags" : [...r.tags],
		}
		
		setShowLevel((prev)=>({...prev, ['currentR']:tmp}))
	}
	/*const areEqual = (prevProps, nextProps) => {
		console.log(prevProps);
		console.log(nextProps);
  if (prevProps === nextProps) {
    return true                                    // donot re-render
  }
  return false                                     // will re-render
}



	const LevelChoosableModel = React.memo(({allTagLevels}) => (<div className="modal-level-tag-level-list-holder">
						{
							allTagLevels.map((v)=>(
									<div key={"all-tag-levels-" + v.tagLevel} className="modal-level-tag-level-card-holder">
										<div className="modal-level-tag-level-list general-blue-label">
											{v.tagLevel}
										</div>
										<div>
											<div className="modal-level-tag-level-list-nd">
												{v.rcLevels.map((r)=>(
														<div  key={"all-tag-levels-sub-" + r.rcLevel} className="modal-level-tag-level-list-nd-btn">
															<div className=" general-green-btn general-green-btn-default" 
																onClick={()=>chooseLevel(r)}
																onMouseEnter={() => showOptionLevel(r)}
															>
																{r.rcLevel}
															</div>
														</div>
													))}
											</div>
										</div>
									</div>
								))
						}
					</div>), areEqual)*/
	
	const TagModal = () => {
		return (
			<div className={show ? "modal" : "modal-hide"}>
				<div className="modal-content-wrapper">
					<div className="modal-content-header">Edit Tag</div>
					<div className="modal-content-detail">
							{updateData.tags.map((v)=>{
								let className = "modal-content-tag ";
								
								if (rawData.tags.find(obj =>(obj.tag === v.tag))) {
									className += "general-blue-btn general-blue-btn-default";
								} else {
									className += "general-green-btn general-green-btn-default";
								}
								
								return (
									<div key={"act-"+v.tag} className={className}
										onClick={()=>{
												
													setUpdateData(
														(prev)=>{
															let tmp = updateData.tags.filter(
																(data) => data.tag != v.tag
															);
															return {...prev, ['tags']:tmp}
														}
													);
											}
										}
									
									>{v.nameHk}</div>
								)
							})}
					</div>
					<div className="modal-content-detail">
							{rawData.allTags
								.filter(value => {
									
										let tmp = updateData.tags.find(obj =>(obj.tag === value.tag));
										if (tmp) {
											return false;
										}
										
										return true;
									}
								)
								.map((v)=>{
									let className = "modal-content-tag ";
									
									if (rawData.tags.find(obj =>(obj.tag === v.tag))) {
										className += "general-blue-btn general-blue-btn-default";
									} else {
										className += "general-green-btn general-green-btn-default";
									}
									
									return <div key={"tag-"+ v.tag} className={className}
										onClick={()=>{
											setUpdateData(
												(prev)=>{
													let tmp = updateData.tags;
													tmp.push(v);
													return {...prev, ['tags']:tmp}
												}
											);
										}}
									>{v.nameHk}</div>}
								)
							}
					</div>
					<div className={"modal-content-confirm-btn " + (isTagsDiff() ? "general-red-btn general-red-btn-default" : "general-btn-disabled")}
						onClick={()=>updateTags()}
						
					>confirm & update</div>
					
				</div>
				<div className="modal-backdrop" onClick={()=>{ setShow(false)}}/>
			</div>);
	}

	return (
		<div id="container">	
			<TagModal/>
			
			
			
			
			
			<div className={displayLevelModal ? "modal" : "modal-hide"}>
				<div className="modal-content-wrapper-level">
				{(displayLevelModal) && <div className="modal-content-header">Edit Level Tag (Sid:{updateData.levels[currentLevelIndex].sid})</div>}
					<div className="modal-level-tag-level-list-detail">
						<div className="modal-level-tag-level-list-nd-btn">
							{displayLevelModal && <div className="general-green-label">{updateData.levels[currentLevelIndex].rcLevel}</div>}
						</div>
						<div className="modal-level-tag-level-list-nd-btn">
						=>
						</div>
						{
							displayLevelModal &&
							updateData.levels[currentLevelIndex].tagLevels.map((v)=>{
								return (
									<div key={"tag-levels-" + v} className="modal-level-tag-level-list-nd-btn">
										<div className="general-blue-label">{v}</div>
									</div>
								);
							})
						}
					</div>
					
					<div className="modal-level-tag-level-list-detail">
					
						{
								(showLevel.currentR && showLevel.confirmClick) && (
									<>
										<div onClick={()=>{setShowLevel((prev)=>({...prev, ['confirmClick']:false}))}} className="modal-level-tag-level-list-nd-btn general-red-btn general-red-btn-default">
											X
										</div>
									</>
								)
						}
						{
							(showLevel.currentR) && (
								<>
									<div className="modal-level-tag-level-list-nd-btn">
										<div className="general-green-label">{showLevel.currentR.rcLevel}</div>
									</div>
									<div className="modal-level-tag-level-list-nd-btn">
									=>
									</div>
									{
										showLevel.currentR.tags.map((v)=>{
											return (
												<div key={"cr-" + v} className="modal-level-tag-level-list-nd-btn">
													<div className="general-blue-label">{v}</div>
												</div>
											);
										})
									}
								</>
							)
						}
						
						{
							(showLevel.currentR && showLevel.confirmClick && showLevel.currentR.rcLevel != updateData.levels[currentLevelIndex].rcLevel) &&(
								<>
									<div className="confirm-btnset">
										<div onClick={() => updateSyllabusRcLevel(currentLevelIndex)} className="modal-level-tag-level-list-nd-btn general-red-btn general-red-btn-default">
											confirm & update
										</div>
									</div>
								</>
							)
						}
						
					</div>
					{/*<LevelChoosableModel firstRun={rawData.allTagLevels}/>*/}
					<div className="modal-level-tag-level-list-holder">
						{
							rawData.allTagLevels.map((v)=>(
									<div key={"all-tag-levels-" + v.tagLevel} className="modal-level-tag-level-card-holder">
										<div className="modal-level-tag-level-list general-blue-label">
											{v.tagLevel}
										</div>
										<div>
											<div className="modal-level-tag-level-list-nd">
												{v.rcLevels.map((r)=>(
														<div  key={"all-tag-levels-sub-" + r.rcLevel} className="modal-level-tag-level-list-nd-btn">
															<div className=" general-green-btn general-green-btn-default" 
																onClick={()=>chooseLevel(r)}
																onMouseEnter={() => showOptionLevel(r)}
															>
																{r.rcLevel}
															</div>
														</div>
													))}
											</div>
										</div>
									</div>
								))
						}
					</div>
				</div>
				<div className="modal-backdrop" onClick={()=>{ 
					setDisplayLevelModal(false)
				}}/>
			</div>
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			<div id="basic-data">
				<div><div>CodeId</div><div>{rawData.codeId}</div></div>
				<div><div>Subject</div><div>{rawData.codeSubject}</div></div>
				<div>
					<div>Title EN</div>
					<div className="input-holder">
						<Form.Control type="text" value={updateData.subCatEn} 
							onChange={
								e => { 
									setUpdateData(prev=>({...prev, subCatEn:e.target.value}))
								}
							} 
						/>
						<div className={"title-update-btn " + ((updateData.subCatEn !== rawData.subCatEn) ? "general-red-btn general-red-btn-default" : "general-btn-disabled")} onClick={()=>updateSubCatEn()}>update</div>
					</div>
				</div>
				<div>
					<div>Title HK</div>
					<div className="input-holder">
						<Form.Control type="text" value={updateData.subCatHk} 
							onChange={
								e => { 
									setUpdateData(prev=>({...prev, subCatHk:e.target.value}))
								}
							} 
						/>
						<div className={"title-update-btn " + ((updateData.subCatHk !== rawData.subCatHk) ? "general-red-btn general-red-btn-default" : "general-btn-disabled")} onClick={()=>updateSubCatHk()}>update</div>
					</div>
				</div>
				<div><div>Language</div><div>{getDisplayLang(rawData.langType)}</div></div>
				<div>
					<div>Tag</div>
					<div className="tags-div">
						<ul className="col-ul">
						{
							rawData.tags.map((v)=>(
								<li key={v.tag} className="general-blue-label">{v.nameHk}</li>
							))
						}
						<li className="tags-div-button general-green-btn general-green-btn-default" onClick={()=>(setShow(true))}>edit</li>
						</ul>
						
					</div>
				</div>
				<div>
					<div>Tag levels</div>
					<div>
							<ul className="col-ul">
								{rawData.tagLevels.map((v)=>(
								<li key={v} className="general-blue-label">{v}</li>					
								))}
							</ul>
					</div>
				</div>
				<div>
					<div>Levels</div>
					<div className="levels-holder">
						<ul className="levels-ul">{updateData.levels.map((v, index)=>(
							<li key={v.sid} className={(v.itemCnt===0) ? "levels-li-none" : "levels-li-show"}>
								<div className="level-detail-div">
									<div>
										<div><span className="level-detail-bold-red">SID {v.sid}</span></div>
										<div>Total item: {v.itemCnt}</div>
									</div>
								</div>
								<div className="level-detail-div-level">
									<div className="level-detail-div-level-code">
										<div>
											<span className="level-detail-bold general-green-btn general-green-btn-default" 
												onClick={()=>{
													setDisplayLevelModal(true);
													setCurrentLevelIndex(index);
												}}>
												{v.rcLevel}
											</span>
										</div>
									</div>
									<div>
										<div className="level-input">
											<div>EN Name</div>
											<Form.Control type="text" value={v.levelEn} 
												onChange={
													e => { 
														let obj = structuredClone(updateData.levels);
														obj[index].levelEn = e.target.value;
														setUpdateData((prev)=>({...prev, ["levels"]:obj}));
														
													}
												} 
											/>
											<div className={(updateData.levels[index].levelEn !== rawData.levels[index].levelEn) ? "general-red-btn general-red-btn-default" : "general-btn-disabled"}
												onClick={()=>updateLevelNameEn(index, v.levelEn)}
											>update</div>
										</div>
										<div className="level-input">
											<div>HK Name</div>
											<Form.Control type="text" value={v.levelHk} 
												onChange={
													e => { 
														let obj = structuredClone(updateData.levels);
														obj[index].levelHk = e.target.value;
														setUpdateData((prev)=>({...prev, ["levels"]:obj}));
													}
												} 
											/>
											<div className={(updateData.levels[index].levelHk !== rawData.levels[index].levelHk) ? "general-red-btn general-red-btn-default" : "general-btn-disabled"}
												onClick={()=>updateLevelNameHk(index, v.levelHk)}
											>update</div>
										</div>
									</div>
									
				
									<div>
										<ul className="tag-levels">
											{v.tagLevels.map((v)=>(
											<li key={v} className="general-blue-label">{v}</li>					
											))}
										</ul>
									</div>
								</div>
							</li>
						))}
						</ul>
					</div>
				</div>
				
				
				
				<div>
					<div>desc EN</div>
					<div className="textarea-holder">
						<textarea className="textarea"
							value={updateData.descriptionEn}
							onChange={(e)=>{setUpdateData((prev)=> ({...prev, ['descriptionEn']:e.target.value}))}}
						/>
					</div>
					
					<div className={"description-update-btn " + ((updateData.descriptionEn !== rawData.descriptionEn) ? "general-red-btn general-red-btn-default" : "general-btn-disabled")} 
						onClick={()=>updateDescriptionEn()}>update</div>
					
				</div>
				<div>
					<div>desc HK</div>
					<div className="textarea-holder">
						<textarea className="textarea"
							value={updateData.descriptionHk}
							onChange={(e)=>{setUpdateData((prev)=> ({...prev, ['descriptionHk']:e.target.value}))}}
						/>
					</div>
					
					<div className={"description-update-btn " + ((updateData.descriptionHk !== rawData.descriptionHk) ? "general-red-btn general-red-btn-default" : "general-btn-disabled")} 
						onClick={()=>updateDescriptionHk()}>update</div>
				</div>
				
				
			</div>
		</div>
  );
}